//Reset data
export const RESET = "TICKET_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "TICKET_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "TICKET_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "TICKET_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "TICKET_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "TICKET_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "TICKET_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "TICKET_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "TICKET_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "TICKET_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "TICKET_CREATE_SET_CREATED"
export const SET_IS_CREATED = "TICKET_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "TICKET_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "TICKET_CREATE_SET_CURRENT_ITEM"
